import { useState } from 'react'
import Box from '@mui/material/Box'
import FormControl from '@mui/material/FormControl'
import MenuItem from '@mui/material/MenuItem'
import ClickAwayListener from '@mui/material/ClickAwayListener'
import { max } from 'lodash-es'
import styled from '@emotion/styled'

import Select from 'components/common/Select'

const Modal = styled.div`
  ${({ theme, $top, $left, $right, $alignRight, $width, $maxHeight }) => `
    position: absolute;
    top: ${$top}px;
    left: ${$left}px;
    right: ${$right}px;
    width: ${$width}px;
    min-height: 100px;
    max-height: ${$maxHeight}px;
    background-color: white;
    z-index: 1;
    border-radius: ${$alignRight ? '20px 0px 20px 20px' : '0px 20px 20px 20px'};
    box-shadow: 0px 4px 10px rgba(0, 0, 0, 0.1);
    border: 1px solid ${theme.palette.background.line};
    overflow: auto;
    padding: 24px 24px 48px 24px;
  `}
`

const PopupSelect = ({
  placeholder,
  selectedText,
  modalContent,
  onOpen,
  closeModalOnInnerClick,
  fullWidth,
}) => {
  const [modal, setModal] = useState({ open: false })

  const onSelectClick = (e) => {
    const top = e.target.clientHeight - 2
    const width =
      window.innerWidth < 768
        ? Math.floor(window.innerWidth * 0.9)
        : Math.floor(window.innerWidth * 0.4)
    const modalRectTop =
      e.target.getBoundingClientRect()?.top + e.target.clientHeight - 2
    const maxHeight = max([window.innerHeight - modalRectTop, 250])

    const modalRectLeft = e.target.getBoundingClientRect()?.left
    const alignRight = modalRectLeft + width > window.innerWidth
    const left = alignRight ? 'unset' : 0
    const right = alignRight ? 0 : 'unset'
    setModal({
      open: !modal.open,
      top,
      left,
      right,
      width,
      maxHeight,
      alignRight,
    })
    if (!modal.open && onOpen) {
      onOpen()
    }
  }

  const onFilterChange = (filters) => {
    setModal({ open: false })
    setFilters(filters)
  }

  const onModalClick = () => {
    if (closeModalOnInnerClick) {
      setModal({ open: false })
    }
  }

  return (
    <ClickAwayListener onClickAway={() => setModal({ open: false })}>
      <Box position="relative">
        <FormControl fullWidth={fullWidth}>
          <Select
            open={false}
            value={!!selectedText || ''}
            native={false}
            size="large"
            displayEmpty
            onClick={onSelectClick}
          >
            <MenuItem value="">{placeholder}</MenuItem>
            <MenuItem value={true}>{selectedText}</MenuItem>
          </Select>

          {modal.open && (
            <Modal
              $top={modal.top}
              $left={modal.left}
              $right={modal.right}
              $alignRight={modal.alignRight}
              $width={modal.width}
              $maxHeight={modal.maxHeight}
              onClick={onModalClick}
            >
              {modalContent}
            </Modal>
          )}
        </FormControl>
      </Box>
    </ClickAwayListener>
  )
}

PopupSelect.defaultProps = {
  placeholder: '',
  selectedText: '',
  closeModalOnInnerClick: true,
}

export default PopupSelect
